(function () {
  'use strict';

  document.querySelectorAll('[data-tabs]').forEach(function (tabGroup) {
    var buttons = Array.from(tabGroup.querySelectorAll('[data-tab-btn]'));
    var panels  = Array.from(document.querySelectorAll('[data-tab-panel]'));

    function activate(target) {
      buttons.forEach(function (b) {
        var isActive = b.dataset.tabBtn === target;
        b.classList.toggle('is-active', isActive);
        b.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.tabPanel === target);
      });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () { activate(btn.dataset.tabBtn); });
    });

    if (buttons.length) activate(buttons[0].dataset.tabBtn);
  });

  document.querySelectorAll('[data-write-review]').forEach(function (button) {
    var panel = button.closest('[data-tab-panel]');
    var form = panel ? panel.querySelector('[data-review-form]') : null;
    if (!form) return;

    button.addEventListener('click', function () {
      form.hidden = !form.hidden;
      if (!form.hidden) {
        var firstField = form.querySelector('input, select, textarea');
        if (firstField) firstField.focus();
      }
    });
  });

  document.querySelectorAll('[data-review-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var success = form.querySelector('[data-review-success]');
      form.reset();
      if (success) success.hidden = false;
    });
  });
})();
